// extracted by mini-css-extract-plugin
module.exports = {"card__container":"style_card__container__3QFi7","play":"style_play__P4W5V","favorite__check":"style_favorite__check__Febzl"};